import * as React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export default function ServiceCard(props) {
  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardMedia
        sx={{ height: 140 }}
       // image="images/La regionale Exchange.jpeg"
        image={`${process.env.REACT_APP_BASE_FILE_URL}/services/${props.image}`}
        title="Exchange Fidilité"
      />

      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {props.titre}
        </Typography>
        <Typography variant="body2" color="text.secondary">
        {props.description}
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" >Plus de détails</Button>
      </CardActions>
    </Card>
  );
}
